const CLOSE_DELAY = 100;
const LOGGED_IN = 'loggedin';

var $optionBar;

let $ = window.jQuery;

function onDocumentReady() {

	$optionBar = $( '#announcement-bar' );
	initialize();
}

function initialize() {

	if ( getCookie( 'info_bar' ) === LOGGED_IN ) {
		destroy();
	} else {
		if ( $optionBar.length > 0 ) {
			$optionBar.css( 'display', '' );
			$( 'body' ).addClass( 'has-announcementbar' );
			$optionBar.on( 'click', '.dismiss', onClickClose );
		}
	}

}

function onClickClose() {
	setCookie( 'info_bar', LOGGED_IN )
	setTimeout( destroy, CLOSE_DELAY );
}

function destroy() {
	$( 'body' ).removeClass( 'has-announcementbar' ).removeClass( 'no-announcementbar' );
	$optionBar.remove();
}

function setCookie( cname, cvalue, exdays ) {
	var d = new Date();
	d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie( cname ) {
	var name = cname + "=";
	var ca = document.cookie.split( ';' );
	for ( var i = 0; i < ca.length; i++ ) {
		var c = ca[i];
		while ( c.charAt( 0 ) === ' ' ) {
			c = c.substring( 1 );
		}
		if ( c.indexOf( name ) === 0 ) {
			return c.substring( name.length, c.length );
		}
	}
	return "";
}

document.addEventListener( 'DOMContentLoaded', onDocumentReady );
